import React from 'react'
import HeroSection from '../HeroSection/HeroSection'
import TransformationProgram from '../TransformationProgram/TransformationProgram'
import HowItWorks from '../HeroSection/HowItWorks/HowItWorks'
import ImageCarousel from '../ImageCarousel/ImageCarousel'
import ImageCarouselT from '../ImageCarousel/ImageCarouselT'
import ProfilePage from '../profile/ProfilePage'
import Facts from '../Fact/Facts'
import FAQ from '../FAQItem/FAQItem'
import LogoMarqueeSection from '../LogoMarqueeSection/LogoMarqueeSection'
import AppreciationPage from '../AppreciationPage/AppreciationPage'
import Footer from '../Footer/Footer'
import ButtonPage from '../ButtonPage/ButtonPage'
import ButtonPage1 from '../ButtonPage/ButtonPage1'
import Hero from '../HeroSection/Hero'
import ImageCarousel1 from '../ImageCarousel/ImageCarousel1'
import ImageCarouselT1 from '../ImageCarousel/ImageCarouselT1'

const HomeNew = () => {
  return (
    <div> 
        <Hero/>
        <ProfilePage/>
        <LogoMarqueeSection/>
        <AppreciationPage/>
        <ImageCarousel1/>
        <TransformationProgram/>
        <ImageCarouselT1/>
      
        <Facts/>
        <FAQ/>
        
        <Footer/>
    </div>
  )
}

export default HomeNew